<template>
  <div
    class="tooth"
    v-click-outside="onCloseMenu">
    <tooth-popover-menu v-bind:value="isShowMenu">
      <template slot="trigger">
        <div class="tooth__body">
          <button
            class="tooth__body__bone"
            type="button"
            v-bind:class="{ selected: isSelected('bone') }"
            v-bind:style="{ 'background-color': partColor['bone'] || '#ffead2' }"
            v-on:click="onClick('bone', $event)" />
          <button
            class="tooth__body__gingiva"
            type="button"
            v-bind:class="{ selected: isSelected('gingiva') }"
            v-bind:style="{ 'background-color': partColor['gingiva'] || '#f4ddc1' }"
            v-on:click="onClick('gingiva', $event)" />
          <button
            class="tooth__body__all-tooth"
            type="button"
            v-on:click="onAllToothClick($event)" />
          <svg
            v-if="!isDeleted"
            class="tooth-up-1 tooth__parts"
            v-bind:class="{ flip }"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 68 179">
            <g v-if="isDiagnosisImplant" id="implant">
              <rect width="25.564" height="13.231" x=".5" y="-.5" fill="#A8BEC5" stroke="#778F9F" rx="1.397" transform="matrix(1 0 0 -1 23.066 73.566)" />
              <path fill="#778F9F" stroke="#778F9F" stroke-width=".949" d="M46.764 56.976H25.932l4.836-55.777h11.904l4.092 55.777Z" />
              <rect width="29.845" height="4.309" x="21.425" y="56.501" fill="#A8BEC5" stroke="#778F9F" stroke-width=".949" rx="1.146" />
              <path fill="#A8BEC5" stroke="#778F9F" stroke-linecap="round" stroke-width=".949" d="M23.268 52.317a1.68 1.68 0 0 0 1.94 1.373l23.52-4.033.168-.037a1.68 1.68 0 0 0-.736-3.274l-23.52 4.032a1.68 1.68 0 0 0-1.372 1.94Zm2.434-5.266.17-.02 22.176-3.696a1.68 1.68 0 1 0-.552-3.314L25.32 43.717l-.168.037a1.68 1.68 0 0 0 .55 3.297Zm.339-6.325.172-.02 21.84-3.696a1.68 1.68 0 0 0-.561-3.313l-21.84 3.695-.169.037a1.68 1.68 0 0 0 .558 3.297Zm-.759-7.729a1.68 1.68 0 0 0 1.93 1.386l20.496-3.36a1.68 1.68 0 0 0-.544-3.315l-20.496 3.36a1.68 1.68 0 0 0-1.386 1.929Zm2.142-4.925.17-.024 19.153-3.695a1.68 1.68 0 0 0-.636-3.3L26.957 24.75l-.166.04a1.68 1.68 0 0 0 .633 3.282Zm.671-5.988.17-.024 17.472-3.36.168-.041a1.68 1.68 0 0 0-.802-3.258L27.63 18.76l-.168.04a1.68 1.68 0 0 0 .632 3.284Zm.295-6.658.17-.02 16.128-2.688a1.68 1.68 0 1 0-.552-3.314l-16.128 2.688-.168.037a1.68 1.68 0 0 0 .55 3.297Zm.39-6.329.17-.025 15.12-3.024.167-.042a1.68 1.68 0 0 0-.827-3.253L28.29 5.777l-.167.042a1.68 1.68 0 0 0 .656 3.278Z" />
            </g>
            <g v-else>
              <path
                d="M28.988 48.915c-1.107 3.452-1.853 15.139-2.088 20.55l18.373 1.953c-.142-9.008-.629-30.497-1.434-44.39-.805-13.892-5.621-22.64-7.929-25.277-.377-.548-1.41-1.11-2.517 1.027-1.384 2.672-2.013 13.05-2.14 20.14-.125 7.09-.88 21.681-2.265 25.997Z"
                v-bind:class="{ selected: isSelected('root_1') }"
                v-bind:fill="partColor['root_1'] || '#FFF'"
                v-on:click="onClick('root_1', $event)"
                v-on:keydown="onClick('root_1', $event)" />
              <path
                d="m40.228 55.792.069-.189c.135-.37.17-.769.105-1.158-2.268-13.455-2.35-30.273-2.868-34.336a1.553 1.553 0 0 0-.433-.874c-.262-.276-.661-.456-.942-.198-.24.22-.472.645-.487 1.472-.218 12.313-.624 27.138-1.877 34.061l-.131.781a1.36 1.36 0 0 0 .905 1.514l.326.11.904.117 1.348.002c.326 0 .652-.023.975-.069l.584-.083c.14-.02.279-.05.414-.093.514-.16.924-.55 1.108-1.057Z"
                v-bind:class="{ selected: isSelected('central_canal') }"
                v-bind:fill="partColor['central_canal'] || '#FF82BE'"
                v-on:click="onClick('central_canal', $event)"
                v-on:keydown="onClick('central_canal', $event)" />
            </g>
            <path
              v-if="!isDiagnosisImplant || hasCrownOnImplant"
              d="m45.097 98.106-16.218.096a15.175 15.175 0 0 1-2.534-.198s-2.816-5.447-2.647-8.71c.216-4.161.749-9.763 1.892-14.924.327-1.474.778-2.77 1.31-3.904 1.925-4.105 4.914-6.104 6.93-6.826.618-.221 1.277-.264 1.932-.264 1.263 0 2.535.198 3.612.858 1.764 1.08 3.995 3.01 5.094 5.82a32.596 32.596 0 0 1 .951 2.862c2.039 7.178 2.812 14.758 2.447 22.21-.054 1.105-.377 1.844-.743 2.312-.463.593-1.274.668-2.026.668Z"
              v-bind:class="{ selected: isSelected('crown') }"
              v-bind:fill="partColor['crown'] || '#FFF'"
              v-on:click="onClick('crown', $event)"
              v-on:keydown="onClick('crown', $event)" />
          </svg>
          <svg
            v-else-if="isBoneImplant"
            class="tooth-up-1 tooth__parts"
            v-bind:class="{ flip }"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 68 179">
            <g id="implant">
              <rect width="25.564" height="13.231" x=".5" y="-.5" fill="#A8BEC5" stroke="#778F9F" rx="1.397" transform="matrix(1 0 0 -1 23.066 73.566)" />
              <path fill="#778F9F" stroke="#778F9F" stroke-width=".949" d="M46.764 56.976H25.932l4.836-55.777h11.904l4.092 55.777Z" />
              <rect width="29.845" height="4.309" x="21.425" y="56.501" fill="#A8BEC5" stroke="#778F9F" stroke-width=".949" rx="1.146" />
              <path fill="#A8BEC5" stroke="#778F9F" stroke-linecap="round" stroke-width=".949" d="M23.268 52.317a1.68 1.68 0 0 0 1.94 1.373l23.52-4.033.168-.037a1.68 1.68 0 0 0-.736-3.274l-23.52 4.032a1.68 1.68 0 0 0-1.372 1.94Zm2.434-5.266.17-.02 22.176-3.696a1.68 1.68 0 1 0-.552-3.314L25.32 43.717l-.168.037a1.68 1.68 0 0 0 .55 3.297Zm.339-6.325.172-.02 21.84-3.696a1.68 1.68 0 0 0-.561-3.313l-21.84 3.695-.169.037a1.68 1.68 0 0 0 .558 3.297Zm-.759-7.729a1.68 1.68 0 0 0 1.93 1.386l20.496-3.36a1.68 1.68 0 0 0-.544-3.315l-20.496 3.36a1.68 1.68 0 0 0-1.386 1.929Zm2.142-4.925.17-.024 19.153-3.695a1.68 1.68 0 0 0-.636-3.3L26.957 24.75l-.166.04a1.68 1.68 0 0 0 .633 3.282Zm.671-5.988.17-.024 17.472-3.36.168-.041a1.68 1.68 0 0 0-.802-3.258L27.63 18.76l-.168.04a1.68 1.68 0 0 0 .632 3.284Zm.295-6.658.17-.02 16.128-2.688a1.68 1.68 0 1 0-.552-3.314l-16.128 2.688-.168.037a1.68 1.68 0 0 0 .55 3.297Zm.39-6.329.17-.025 15.12-3.024.167-.042a1.68 1.68 0 0 0-.827-3.253L28.29 5.777l-.167.042a1.68 1.68 0 0 0 .656 3.278Z" />
            </g>
            <path
              v-if="hasCrownOnImplant"
              d="m45.097 98.106-16.218.096a15.175 15.175 0 0 1-2.534-.198s-2.816-5.447-2.647-8.71c.216-4.161.749-9.763 1.892-14.924.327-1.474.778-2.77 1.31-3.904 1.925-4.105 4.914-6.104 6.93-6.826.618-.221 1.277-.264 1.932-.264 1.263 0 2.535.198 3.612.858 1.764 1.08 3.995 3.01 5.094 5.82a32.596 32.596 0 0 1 .951 2.862c2.039 7.178 2.812 14.758 2.447 22.21-.054 1.105-.377 1.844-.743 2.312-.463.593-1.274.668-2.026.668Z"
              v-bind:class="{ selected: isSelected('crown') }"
              v-bind:fill="partColor['crown'] || '#FFF'"
              v-on:click="onClick('crown', $event)"
              v-on:keydown="onClick('crown', $event)" />
          </svg>
        </div>
      </template>
      <form-teeth-formula-diagnoses
        v-bind:class="{ 'disable-component': disabled }"
        v-bind:is-deleted="needDeleted"
        v-bind:part-list="partList"
        v-bind:has-implant="hasImplant"
        v-on:cancel="onCloseMenu"
        v-on:change-diagnoses="onChangeDiagnoses"
        v-on:change-tooth-deleted="onChangeToothDeleted"
        v-on:submit="onSubmit" />
    </tooth-popover-menu>
    <top-tooth-surface
      v-bind:surface="surface"
      v-bind:part-selected="partSelected"
      v-bind:selected-parts="selectedParts"
      v-bind:flip="flip"
      v-on:select="onClick" />
    <div class="tooth__number">{{ tooth.number }}</div>
  </div>
</template>
<script>
import toothMixin from '@/mixins/toothMixin';
import ToothPopoverMenu from '../ToothPopoverMenu.vue';
import FormTeethFormulaDiagnoses from '../FormTeethFormulaDiagnoses.vue';
import TopToothSurface from '../TopToothSurface.vue';

export default {
  components: {
    ToothPopoverMenu,
    FormTeethFormulaDiagnoses,
    TopToothSurface,
  },
  mixins: [toothMixin],
  name: 'ToothUp1',
};
</script>

<style></style>
